import Vue from 'vue'

// ─── Z-index ──────────────────────────────────────────────────────────────────
let _zCounter = 1000
export function nextZ()    { return ++_zCounter }
export function currentZ() { return _zCounter }

// ─── Window identity ──────────────────────────────────────────────────────────
let _windowCounter = 0
export function nextWindowId() { return ++_windowCounter }

// ─── Minimize registry ────────────────────────────────────────────────────────
export const MAX_MINIMIZED = 20

export const minimizeRegistry = Vue.observable({ windows: [] })

// ─── Portal registry ──────────────────────────────────────────────────────────
// Maps portal name → { windowsEl: HTMLElement, taskbarEl: HTMLElement }
export const portalRegistry = {}

export function registerPortal(name, els) {
    portalRegistry[name] = els
}

export function unregisterPortal(name) {
    delete portalRegistry[name]
}

export function getPortal(name) {
    return portalRegistry[name] || null
}